export default __webpack_public_path__ + "static/media/icon-2.a88cbc6d.svg";